





































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import LetEditable from "@/components/LetEditable.vue";
import Decimal from "@/components/inputs/Decimal.vue";
import Editor from '@tinymce/tinymce-vue';

class paymentTypes {
    payment_type_id!:number;
    add_price:number = 0;
    discount:number = 0;
    enabled:number = 0;
    name!:string;
    no!:number;
    success_title:string="";
    success_message:string="";
}
@Component({
    components: {
        Decimal,
        LetEditable,
        EnabledSwitch,
        DeleteButton,EForm,Number,TextField,Id,Editor
    }
})
export default class PaymentTypes extends  Vue{
    items : paymentTypes[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "paymentTypes";
    action:string = this.baseAction;
    data : paymentTypes = new paymentTypes();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "payment_type_id"
        },
        {text: "Başlık", value: "name"},
        {text: "İndirim", value: "discount"},
        {text: "Aktif", value: "enabled"},
        {text: "Sıra", value: "no"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:paymentTypes){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.payment_type_id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new paymentTypes();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
